"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var themesSize = {
  small: {
    fontSize: 12
  },
  medium: {
    fontSize: 14
  },
  large: {
    fontSize: 16
  },
  largest: {
    fontSize: 24
  }
};
var themesColor = {
  white: {
    color: '#FFF'
  },
  black: {
    color: '#4a4a4a'
  }
};
var themesFont = {
  regular: {
    fontFamily: '\'Nunito Sans\', sans-serif'
  },
  semiBold: {
    fontFamily: '\'Nunito Sans\', sans-serif'
  },
  bold: {
    fontFamily: '\'Nunito Sans\', sans-serif'
  }
};
var getTheme = function getTheme(typeColor, typeFont, typeSize, theme) {
  return _objectSpread(_objectSpread({}, theme), {}, {
    text: _objectSpread(_objectSpread(_objectSpread({}, themesColor[typeColor] || themesColor.black), themesFont[typeFont]), themesSize[typeSize])
  });
};
var _default = exports["default"] = getTheme;